@if (showBootLoader()) {
  <div id="app" class="shell-loader loading all-white">
    <div class="sk-cube-grid placeholder-ie hidden" aria-hidden="true">
      <div class="sk-cube sk-cube1"></div>
      <div class="sk-cube sk-cube2"></div>
      <div class="sk-cube sk-cube3"></div>
      <div class="sk-cube sk-cube4"></div>
      <div class="sk-cube sk-cube5"></div>
      <div class="sk-cube sk-cube6"></div>
      <div class="sk-cube sk-cube7"></div>
      <div class="sk-cube sk-cube8"></div>
      <div class="sk-cube sk-cube9"></div>
    </div>
    <svg class="placeholder" version="1.1" x="0px" y="0px" viewBox="0 0 282 148" overflow="visible" enable-background="new 0 0 282 148" xml:space="preserve" aria-hidden="true">
      <path fill="rgba(0, 0, 0, 0)" stroke-width="2" stroke-miterlimit="10" d="M141,147.902L281.5,80.15V52.362L141,0.533L0.5,52.362V80.15
        l15.299,7.492v-4.06c0-4.371,2.186-6.869,5.308-5.62l15.923,7.49c2.811,1.249,5.309,6.245,5.309,10.615v4.06l44.647,21.543V117.3
        c0-4.684,2.498-7.181,5.933-5.929l17.796,8.427c3.435,1.562,5.933,6.869,5.933,11.554v4.371L141,147.902 M125.701,104.191
        l-4.996-2.188L185.96,73.28l4.995,1.872L125.701,104.191z M196.264,72.657l-4.996-1.874l59.01-25.915l4.686,1.874L196.264,72.657z
        M70.75,79.213l65.254-26.539l4.371,1.874L75.121,81.398L70.75,79.213z M141.624,50.489l58.698-24.041l4.371,1.561l-58.698,24.354
        L141.624,50.489z M122.267,42.371l-4.371-1.874l58.697-23.104l4.368,1.562L122.267,42.371z M116.646,44.869L51.704,70.783
        l-4.371-2.186l64.942-25.602L116.646,44.869z M95.415,90.453l65.255-27.475l4.684,1.873L100.1,92.639L95.415,90.453z M165.979,60.48
        l58.697-24.978l4.684,1.873l-58.696,24.978L165.979,60.48z M99.162,33.004l-4.059-1.561L153.8,8.963l4.062,1.561L99.162,33.004z
        M93.542,35.19L28.6,60.167l-4.059-1.873l64.942-24.666L93.542,35.19z M276.504,79.525L276.504,79.525l-17.172-6.559l-41.214,19.047
        v-7.807l58.386-26.851V79.525z M147.244,125.109v-8.117l65.255-29.973v23.416l-17.483-7.492l-45.586,21.229l-2.186,12.489V125.109
        L147.244,125.109z"></path>
    </svg>
    <h5 id="app-loading-text">Loading user. This could take a few seconds.</h5>
  </div>
} @else {
  <div id="header" class="shell-header">
    <div class="navbar navbar-default">
      <ul class="nav navbar-nav navbar-left">
        <li><a class="navbar-item" routerLink="/dashboard" routerLinkActive="active">Dashboard</a></li>
        @if (canAccessManageOrders()) {
          <li><a class="navbar-item" routerLink="/manage-orders" routerLinkActive="active">Manage Orders</a></li>
        }
        @if (canAccessAdministration()) {
          <li><a class="navbar-item" routerLink="/administration" routerLinkActive="active">Administration</a></li>
        }
        @if (canAccessReports()) {
          <li><a class="navbar-item" routerLink="/reports" routerLinkActive="active">Reports</a></li>
        }
        <li><a class="navbar-item" routerLink="/help-support" routerLinkActive="active">Help and Support</a></li>
        <li>
          <button type="button" class="navbar-item" (click)="payInvoice()">
            Pay Invoice By Credit Card
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li>
          <button type="button" class="navbar-item" (click)="openSearch()">Search</button>
        </li>
        <li>
          <button type="button" class="navbar-item" (click)="openNotifications()">
            Notifications ({{ unreadNotificationCount() }})
          </button>
        </li>
        <li>
          <button type="button" class="navbar-item shell-logout" (click)="logout()">Logout</button>
        </li>
      </ul>
    </div>
  </div>

  <main class="shell-main">
    <router-outlet></router-outlet>
  </main>

  <app-sidebar-panel />
  <app-loading-overlay />
}
